import * as Sentry from '@sentry/react';

import { Consents } from 'consts/gdpr';
import { gdpr } from 'utils';

const okayToUseSentry = () =>
  import.meta.env.REACT_APP_SENTRY_RELEASE &&
  import.meta.env.REACT_APP_SENTRY_ENVIRONMENT &&
  import.meta.env.REACT_APP_SENTRY_DSN &&
  gdpr.getConsentValue().includes(Consents.Necessary);

const init = () => {
  if (okayToUseSentry()) {
    Sentry.init({
      dsn: import.meta.env.REACT_APP_SENTRY_DSN,
      release: import.meta.env.REACT_APP_SENTRY_RELEASE,
      environment: import.meta.env.REACT_APP_SENTRY_ENVIRONMENT,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
    });
  }
};

const setUser = (user: Sentry.User | null) => {
  if (okayToUseSentry()) {
    Sentry.setUser(user);
  }
};

export const sentry = {
  init,
  setUser,
  ErrorBoundary: Sentry.ErrorBoundary,
  withScope: Sentry.withScope,
  captureMessage: Sentry.captureMessage,
};
